import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ContactRequest {
  eMail: string;
  inputName: string;
  messageArea: string;
}

export interface ContactResponse {
  status: string;
  message: string;
}


@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private readonly mail = 'https://kaeltemeister.de/mailing';

  constructor(private readonly http: HttpClient) {}

  PostMessage(input: ContactRequest): Observable<ContactResponse> {
    return this.http.post<ContactResponse>(this.mail, input);
  }
}
